export const Sizes = {
  BREAKPOINT_MOBILE: 768,
  BREAKPOINT_TABLET: 1049,
  CONTEXT_MENU_WIDTH: 180,
};